// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"af6a86583978cd47","6857":"9dbff2e13711323a"}[chunkId] + ".css";
};